module.exports = __webpack_public_path__ + "static/media/WinterborneHome1.2445149e.jpg";